import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import numeral from 'numeral';
import axios from 'axios';

import { makeStyles } from '@material-ui/core/styles';

import { paramConverter, addAllList } from 'modules/common';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { showSuccessSnackbar } from 'modules/snackbar';
import { setPortal } from 'modules/portal';
import {
  ManageGoodsInfoList,
  manageGoodsInfoCount,
  goodsinfoAdverList,
  manageGoodsInfoModify,
  manageGoodsInfoDelete,
  goodsInfoHeadUpLoad,
} from 'lib/api/goods';
import { bigAdver } from 'lib/api/auth';

import Avatar from 'components/atoms/Avatar';
import NewInput from 'components/atoms/NewInput';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import NewCheckbox from 'components/molecules/NewCheckbox';
import NewTableContainer from 'components/molecules/NewTable';
import MbRadioGroup from 'components/molecules/MbRadioGroup';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import AutoComplete from 'components/molecules/NewSelectBox/AutoComplete';
import Modal from 'components/organisms/NewModal';
import SwitchingArea from 'components/organisms/SwitchingArea';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';

import JsonUpLoad from './JsonUpLoad';

const useStyles = makeStyles((theme) => ({
  addFuncBox: {
    display: 'flex',
    '& > div': { marginRight: 10, '&:last-child': { marginRight: 0 } },
  },
}));

const ProductManagementGoodsInfoList = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  let initParam = {
    url: '/product/collection/goodsinfo',
    sort: 'desc',
    order: 'FIRST_DATE',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    pltfomTpCode: '01',
    sImageInfo: 'all',
    sLiveCheck: 'all',
    menualPrdtFlag: false,
    sUserId: '',
    sCategory: '',
    sGoodsCode: '',
    sGoodsNM: '',
    sImageNM: '',
    matState: '01',
    limit: '70',
  };

  const [tempParams, setTempParams] = useState(initParam);

  const [initialization, setInitialization] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [params, setParams] = useState(initParam);
  const [adverList, setAdverList] = useState([]);
  const [reFetch, setReFetch] = useState(false);
  const [tableListCount, setTableListCount] = useState(0);
  const [jsonUpLoad, setJsonUpLoad] = useState({ open: false });
  const [bigAdverList, setBigAdverList] = useState([]);
  const [isBigAdver, setIsBigAdver] = useState(false);

  const filterList = {
    sImageInfo: [
      { CODE_ID: 'all', CODE_DESC: t('전체') },
      { CODE_ID: '01', CODE_DESC: t('확장자 있음') },
      { CODE_ID: '02', CODE_DESC: t('확장자 없음') },
    ],
    sLiveCheck: [
      { value: '01', label: t('게재') },
      { value: '02', label: t('중지') },
      { value: '03', label: t('품절') },
    ],
    adverStatus: [
      { value: '01', label: t('게재') },
      { value: '02', label: t('중지') },
    ],
    matState: [
      { value: 'all', label: t('전체') },
      { value: '01', label: t('일반 이미지') },
      { value: '02', label: t('다중 이미지') },
    ],
    pltfomTpCode: [
      { value: '01', label: t('웹') },
      { value: '02', label: t('모바일') },
    ],
    goodsType: [
      { value: '02', label: t('상품코드') },
      { value: '03', label: t('상품명') },
    ],
  };
  const initModal = {
    open: false,
    headerTitle: '수정',
    confirmBtnTitle: '수정',
    params: [],
    goodsKeys: [],
  };
  const [modal, setModal] = useState(initModal);

  const upLoadTableHead = [
    {
      id: 'id',
      label: t('계정ID'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'code',
      label: t('상품코드'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'name',
      label: t('상품명'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'cate',
      label: t('카테고리'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'url',
      label: 'URL',
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'path',
      label: t('상품이미지URL'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'price',
      label: t('가격'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'dcPrice',
      label: t('할인가격'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
    {
      id: 'device',
      label: t('디바이스'),
      orderFlag: false,
      type: null,
      displayFlag: true,
    },
  ];

  useEffect(() => {
    goodsinfoAdverList()
      .then((response) => {
        const { data } = response.data;
        setAdverList(data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    bigAdver()
      .then((response) => {
        const { data } = response.data;
        let newAdverList = [];
        // eslint-disable-next-line array-callback-return
        data.map((item) => {
          newAdverList.push(item['USER_ID']);
        });
        setBigAdverList(newAdverList);
      })
      .catch((error) =>
        handleClickSnackbar({ message: error, option: { type: 'error' } })
      );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (showTable && !isBigAdver) {
      manageGoodsInfoCount({
        ...paramConverter({
          ...params,
          menualPrdtFlag: params['menualPrdtFlag']
            ? params['menualPrdtFlag']
            : null,
        }),
      })
        .then((response) => {
          const { cnt } = response.data.data;
          setTableListCount(cnt);
        })
        .catch((error) => {
          handleClickSnackbar({ message: error, option: { type: 'error' } });
        });
    }
    // eslint-disable-next-line
  }, [params]);

  useEffect(() => {
    if (bigAdverList.includes(tempParams['sUserId'])) {
      setIsBigAdver(true);
      setTableListCount(0);
    } else {
      setIsBigAdver(false);
    }
    // eslint-disable-next-line
  }, [params, tempParams]);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
    if (!!reFetch) {
      setReFetch(false);
    }
  }, [initialization, reFetch]);

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  /**
   * 필터 초기화
   * initialization 필터 내부에서 초기화 버튼이 클릭되었을 때 기본값으로 돌려주는 함수를 실행시킴.
   */
  const handleOnReset = () => {
    setShowTable(false);
    if (
      JSON.stringify(params) !== JSON.stringify(initParam) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParam)
    ) {
      setInitialization(true);
      setParams(initParam);
      setTempParams(initParam);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const modalGetParam = (e, type) => {
    let newModalParams = { ...modal.params };
    if (type === 'adverId' || type === 'goodsKeys') {
      newModalParams = e;
    } else {
      const { value, name } = e.target;
      newModalParams = { ...newModalParams, [name]: value };
    }
    setModal({ ...modal, params: newModalParams });
  };

  /**
   *  검색버튼 클릭시
   */
  const handleButtonOnClick = () => {
    if (!tempParams.sUserId) {
      handleClickSnackbar({
        message: t('계정ID는 필수 입력값 입니다.'),
        option: { type: 'error' },
      });
      setLoading(false);
      setShowTable(false);
    } else {
      let deleteValue = '';
      let newParams = { ...tempParams };
      Object.keys(newParams).forEach(function (key) {
        if (newParams[key] === deleteValue)
          newParams = { ...newParams, [key]: null };
      });
      setParams({ ...params, ...newParams });
      setShowTable(true);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    USER_ID: { orderFlag: false },
    PNM: { headStyle: { width: 200 } },
    CTGR_NM: { orderFlag: true },
    IMAGE_URL: {
      makeBody: (rowObj, headsMap) => {
        return <Avatar src={rowObj['IMAGE_URL']} />;
      },
      merged: params.matState === '02' && true,
    },
    IMAGE_URL2: {
      makeHead: (headsMap) => {
        return t('상품컷');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <Avatar
            src={rowObj['IMAGE_URL2'] === 'N' ? null : rowObj['IMAGE_URL2']}
          />
        );
      },
      merged: params.matState === '01' && true,
    },
    IMAGE_URL3: {
      makeHead: (headsMap) => {
        return t('모델컷');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <Avatar
            src={rowObj['IMAGE_URL3'] === 'N' ? null : rowObj['IMAGE_URL3']}
          />
        );
      },
      merged: params.matState === '01' && true,
    },
    IMAGE_URL4: {
      makeHead: (headsMap) => {
        return t('썸네일컷');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <Avatar
            src={rowObj['IMAGE_URL4'] === 'N' ? null : rowObj['IMAGE_URL4']}
          />
        );
      },
      merged: params.matState === '01' && true,
    },
    IMAGE_URL5: {
      makeHead: (headsMap) => {
        return t('커스텀컷');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <Avatar
            src={rowObj['IMAGE_URL5'] === 'N' ? null : rowObj['IMAGE_URL5']}
          />
        );
      },
      merged: params.matState === '01' && true,
    },
    IMG_CNT: {
      makeHead: (headsMap) => {
        return t('수집 이미지 개수');
      },
      merged: params.matState === '01' && true,
      orderFlag: false,
    },
    PRICE: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PRICE');
        return makeRowColumn(rowObj['PRICE'], bodyItem1.type, bodyItem1.format);
      },
      orderFlag: false,
    },
    PRDT_PRMCT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PRDT_PRMCT');
        return makeRowColumn(
          rowObj['PRDT_PRMCT'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      orderFlag: false,
    },
    ADVER_STATE: {
      makeHead: (headsMap) => {
        return (
            <>
              <InfoTitleArea
                  title={getHeadObj(headsMap, 'ADVER_STATE').label}
                  tooltipTitle={t('실제 상품의 광고 가능 여부')}
                  iconType="fainfoCircle"
              />
            </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj.ADVER_STATE !== '03' ? (
          <NewButton
            title={t('광고상태 on/off')}
            icon="faPowerOff"
            iconBtn
            onClick={() => handleStateToggle(rowObj, 'state')}
            style={
              rowObj.ADVER_STATE === '01' ? { backgroundColor: '#79bd2f' } : {}
            }
            color={rowObj.ADVER_STATE === '01' ? '#fff' : undefined}
          />
        ) : (
          <p
            style={{
              padding: 5,
              backgroundColor: '#ffc90e',
              borderRadius: 4,
              color: '#fff',
            }}
          >
            {t('품절')}
          </p>
        );
      },
    },
    ADVER_STATUS: {
      makeHead: (headsMap) => {
        return (
            <>
              <InfoTitleArea
                  title={getHeadObj(headsMap, 'ADVER_STATUS').label}
                  tooltipTitle={t('모비온의 광고 송출 여부')}
                  iconType="fainfoCircle"
              />
            </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <NewButton
            title={t('광고유무') + ' on/off'}
            icon="faPowerOff"
            iconBtn
            onClick={() => handleStateToggle(rowObj, 'status')}
            style={
              rowObj.ADVER_STATUS === '01' ? { backgroundColor: '#79bd2f' } : {}
            }
            color={rowObj.ADVER_STATUS === '01' ? '#fff' : undefined}
          />
        );
      },
    },
    FIRST_DATE: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['FIRST_DATE'];
      },
    },
    LAST_DATE: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['LAST_DATE'];
      },
    },
  };

  const customizedUpLoad = {
    url: { bodyStyle: { maxWidth: 200 } },
    path: { bodyStyle: { maxWidth: 200, wordBreak: 'break-all' } },
    price: {
      makeBody: (rowObj, headsMap) => {
        return numeral(rowObj['price']).format();
      },
    },
    dcPrice: {
      makeBody: (rowObj, headsMap) => {
        return numeral(rowObj['dcPrice']).format();
      },
    },
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <NewButton
            title={t('사이트로 이동')}
            iconBtn
            icon="faHome"
            disableRipple
            onClick={(e) => handlePortalUrl(data['URL'])}
          />
        );
      },
    });
    return result;
  })();

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  /**
   * 테이블 로우를 수정하기 위한 API 통신 함수
   * @param tempParams
   */
  const handleAdexTransMatchingModify = (tempParams) => {
    setLoading(true);
    manageGoodsInfoModify(tempParams)
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: { type: 'success' },
        });
        setReFetch(true);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setReFetch(false);
        setLoading(false);
      });
  };

  /**
   * 게재 상태 토글 버튼 이벤트 함수
   * @param rowData
   */
  const handleStateToggle = (rowData, type) => {
    const { NO, ADVER_STATE, ADVER_STATUS } = rowData;
    let tempParams = {
      goodsKeys: NO,
      pltfomTpCode: params.pltfomTpCode,
      goodsType: '01',
    };
    if (type === 'status') {
      tempParams = {
        ...tempParams,
        status:
          ADVER_STATUS === '01' ? '02' : ADVER_STATUS === '02' ? '01' : null,
      };
    } else if (type === 'state') {
      tempParams = { ...tempParams, state: ADVER_STATE === '01' ? '02' : '01' };
    }
    handleAdexTransMatchingModify(tempParams);
  };

  const handleBalanceChange = (e) => {
    let newTempParams = { ...tempParams };
    newTempParams = {
      ...newTempParams,
      menualPrdtFlag: !tempParams.menualPrdtFlag,
    };
    setTempParams(newTempParams);
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  };

  const handleSubmit = (type) => {
    let newParams = { ...modal.params };

    if (type === 'stop' || type === 'soldOut') {
      handleAdexTransMatchingModify({
        ...newParams,
        goodsKeys: newParams.goodsKeys.replace(/\n/g, ','),
      });
    } else {
      const productsCode = modal.goodsKeys.map((item, index) => {
        return item;
      });
      if (modal.type === 'edit') {
        handleAdexTransMatchingModify({
          ...newParams,
          goodsKeys: productsCode.toString(),
          pltfomTpCode: params.pltfomTpCode,
        });
      } else if (modal.type === 'delete') {
        setLoading(true);
        manageGoodsInfoDelete({
          ...newParams,
          goodsKeys: productsCode.toString(),
          pltfomTpCode: params.pltfomTpCode,
          adverId: params.sUserId,
        })
          .then((response) => {
            handleClickSnackbar({
              message: response.data.message,
              option: { type: 'success' },
            });
            setReFetch(true);
          })
          .catch((error) => {
            handleClickSnackbar({
              message: error,
              option: { type: 'error' },
            });
          })
          .finally(() => {
            setReFetch(false);
            setLoading(false);
          });
      }
    }
    setModal({ ...modal, open: false });
  };

  /**
   * 체크박스 Btn Callback 함수
   * @param type String (엑션타입)
   * @param rowData Array ( 체크 유니크값)
   */
  const handleheadCallback = (type, dataList) => {
    let newModal = { ...modal };
    let tempNo = [];
    let tempPcode = [];
    dataList.forEach(function (rowData) {
      tempNo.push(rowData.NO);
    });
    dataList.forEach(function (rowData) {
      tempPcode.push(rowData.PCODE);
    });

    if (type === 'edit') {
      let result;
      if (dataList.length > 1) {
        result = { state: '01', status: '01' };
      } else {
        result = {
          state: dataList[0].ADVER_STATE,
          status: dataList[0].ADVER_STATUS,
        };
      }
      result = { ...result, goodsType: '01' };
      newModal = {
        ...newModal,
        open: true,
        params: result,
        headerTitle: '수정',
        confirmBtnTitle: '수정',
      };
    } else if (type === 'delete') {
      newModal = {
        ...newModal,
        open: true,
        headerTitle: t('삭제'),
        confirmBtnTitle: t('삭제'),
      };
    }
    newModal = {
      ...newModal,
      open: true,
      type: type,
      goodsKeys: tempNo,
      productCode: tempPcode,
    };
    setModal(newModal);
  };

  const handleTempParams = (newParams) => {
    let newTempParams = { ...newParams };
    if (
      !!newTempParams['sUserId'] &&
      bigAdverList.includes(newTempParams['sUserId'])
    ) {
      newTempParams = {
        ...newTempParams,
        sGoodsNM: '',
        sCategory: '',
        sImageNM: '',
      };
      handleClickSnackbar({
        message: t('대형 광고주가 선택되었습니다') + '.',
        option: { type: 'info' },
      });
    }
    if (JSON.stringify(tempParams) !== JSON.stringify(newTempParams)) {
      setTempParams(newTempParams);
    }
  };

  const handleTableCallBack = (state) => {
    if (!!state) {
      setLoading(false);
    }
  };

  const handleProductData = (type) => {
    let newModal;

    newModal = {
      open: true,
      type: type,
      headerTitle: type === 'stop' ? t('게재중지') : t('일괄 품절'),
      confirmBtnTitle: type === 'stop' ? t('게재중지') : t('일괄 품절'),
      params: {
        pltfomTpCode: '01',
        adverId: '',
        goodsType: '02',
        goodsKeys: '',
      },
    };
    if (type === 'stop') {
      newModal['params']['state'] = '02';
    } else if (type === 'soldOut') {
      newModal['params']['state'] = '03';
    }
    setModal(newModal);
  };

  const handleJsonUpLoad = () => {
    setJsonUpLoad({ ...jsonUpLoad, open: true });
  };

  /**
   * 파일 다운로드 (임시)
   */
  const downloadFile = () => {
    axios({
      method: 'GET',
      url: '/download/shopdata_sample.xlsx',
      responseType: 'blob', // 가장 중요함
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers['content-type'] })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'shopdata_sample.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  };

  const tableTitle =
    t('총') + ': ' + numeral(tableListCount).format() + t('개');

  return (
    <>
      <SwitchingArea isOpen={false} title={t('추가기능')}>
        <div className={classes.addFuncBox}>
          <NewButton onClick={() => handleProductData('stop')}>
            {t('상품수집데이터 일괄 게재중지')}
          </NewButton>
          <NewButton onClick={() => handleProductData('soldOut')}>
            {t('상품수집데이터 일괄 품절')}
          </NewButton>
          <NewButton onClick={(e) => handleJsonUpLoad()}>
            {t('데이터 일괄 등록')}
          </NewButton>
          <NewButton onClick={(e) => downloadFile(e)}>
            {t('샘플 다운로드')}
          </NewButton>
        </div>
      </SwitchingArea>
      <NewFilterWrap
        loading={loading}
        handleOnReset={handleOnReset}
        handleOnReSearch={() => setReFetch(true)}
        subChildren={
          <>
            <AutoComplete
              list={adverList}
              label={t('광고주ID')}
              name="sUserId"
              valueKey="USER_ID"
              labelKey="USER_ID"
              getParam={handleTempParams}
              params={tempParams}
              type="filter"
            />
            <NewInput
              label={t('상품코드')}
              type="filter"
              name="sGoodsCode"
              params={tempParams}
              value={tempParams['sGoodsCode']}
              callBack={handleTempParams}
            />
            <NewInput
              label={t('상품명')}
              type="filter"
              name="sGoodsNM"
              params={tempParams}
              value={tempParams['sGoodsNM']}
              callBack={handleTempParams}
              disabled={isBigAdver}
            />
            <NewInput
              label={t('카테고리')}
              type="filter"
              name="sCategory"
              params={tempParams}
              value={tempParams['sCategory']}
              callBack={handleTempParams}
              disabled={isBigAdver}
            />
            <NewInput
              label={t('이미지명')}
              type="filter"
              name="sImageNM"
              params={tempParams}
              value={tempParams['sImageNM']}
              callBack={handleTempParams}
              disabled={isBigAdver}
            />
            <NewCheckbox
              label={t('수동 등록 상품')}
              name="menualPrdtFlag"
              onChange={handleBalanceChange}
              checked={tempParams.menualPrdtFlag}
              style={{ marginRight: 10 }}
            />
            <NewButton onClick={handleButtonOnClick}>{t('검색')}</NewButton>
          </>
        }
      >
        <NewCommonFilter
          initialization={initialization}
          getParam={handleTempParams}
          params={tempParams}
          excludeAllPltfomTpCode
          useDisplayFilter={false}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('소재상태')}
          value={params.matState}
          name="matState"
          type="radio"
          params={tempParams}
          list={filterList.matState}
          labelKey="label"
          valueKey="value"
          callBack={handleTempParams}
        />
        <FilterCollection
          label={t('이미지 상태')}
          value={params.sImageInfo}
          name="sImageInfo"
          type="radio"
          params={tempParams}
          list={filterList.sImageInfo}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
          callBack={handleTempParams}
        />
        <FilterCollection
          label={t('광고 상태')}
          value={params.sLiveCheck}
          name="sLiveCheck"
          type="radio"
          params={tempParams}
          list={addAllList(filterList.sLiveCheck, 'label', 'value', 'all')}
          labelKey="label"
          valueKey="value"
          callBack={handleTempParams}
        />
      </NewFilterWrap>

      {showTable ? (
        <NewTableContainer
          params={{
            ...params,
            menualPrdtFlag: params['menualPrdtFlag'] ? '01' : null,
          }}
          getParam={getParam}
          dataReqPromise={ManageGoodsInfoList}
          customized={customized}
          loading={loading}
          useTotal={false}
          useCheckBox
          hasActController={{ edit: true, delete: true }}
          headCallBack={handleheadCallback}
          callBack={handleTableCallBack}
          reFetch={reFetch}
          addColumnList={addColumnList}
          useSearch={false}
          excelItemsRemoval="IMAGE_URL5"
          title={!isBigAdver && tableTitle}
          excelTransKey="ADVER_STATUS,ADVER_STATE"
        />
      ) : (
        <CurrentStatus type="noTable" />
      )}
      <Modal
        open={modal.open}
        headerTitle={modal.headerTitle}
        confirmBtnTitle={modal.confirmBtnTitle}
        confirmBtnOpen
        useForm={modal.type !== 'delete'}
        handleClose={handleModalClose}
        confirmOnClick={
          modal.type === 'stop' || modal.type === 'soldOut'
            ? () => handleSubmit(modal.type)
            : handleSubmit
        }
        style={{ minWidth: 400 }}
      >
        {modal.type === 'edit' ||
          (modal.type === 'delete' && (
            <div style={{ minWidth: 100, maxWidth: 500 }}>
              {t('선택된 상품코드')}
              {': '}
              {modal.productCode.map((item, index) => {
                if (modal.productCode.length - 1 === index) {
                  return item;
                } else {
                  return item + ', ';
                }
              })}
            </div>
          ))}
        {modal.type === 'edit' && (
          <>
            <tr>
              <th>{t('광고상태')}</th>
              <td>
                <MbRadioGroup
                  selectedValue={modal.params.state}
                  radioList={filterList.sLiveCheck}
                  onChange={modalGetParam}
                  name="state"
                />
              </td>
            </tr>
            <tr>
              <th>{t('광고유무')}</th>
              <td>
                <MbRadioGroup
                  selectedValue={modal.params.status}
                  radioList={filterList.adverStatus}
                  onChange={modalGetParam}
                  name="status"
                />
              </td>
            </tr>
          </>
        )}
        {(modal.type === 'stop' || modal.type === 'soldOut') && (
          <>
            <tr>
              <th>{t('웹/모바일 구분')}</th>
              <td>
                <MbRadioGroup
                  selectedValue={modal.params.pltfomTpCode}
                  radioList={filterList.pltfomTpCode}
                  onChange={modalGetParam}
                  name="pltfomTpCode"
                  style={{ marginLeft: -10 }}
                />
              </td>
            </tr>
            <tr>
              <th>{t('광고주 아이디')}</th>
              <td>
                <AutoComplete
                  list={adverList}
                  label={t('광고주ID')}
                  name="adverId"
                  valueKey="USER_ID"
                  labelKey="USER_ID"
                  getParam={(e) => modalGetParam(e, 'adverId')}
                  params={modal.params}
                  type="filter"
                  style={{ width: 200 }}
                />
              </td>
            </tr>
            <tr>
              <th>{t('검색 조건')}</th>
              <td style={{ minWidth: 210 }}>
                <MbRadioGroup
                  selectedValue={modal.params.goodsType}
                  radioList={filterList.goodsType}
                  onChange={modalGetParam}
                  name="goodsType"
                  style={{ marginLeft: -10 }}
                />
              </td>
            </tr>
            <tr>
              <th style={{ minWidth: 300 }}>{t('상품코드/상품명 리스트')}</th>
              <td>
                <NewInput
                  name="goodsKeys"
                  params={modal.params}
                  value={modal.params['goodsKeys']}
                  callBack={(e) => modalGetParam(e, 'goodsKeys')}
                  rows={10}
                  multiline
                  placeholder={
                    '상품코드1\n상품코드2\n상품코드3\n상품코드4\n상품코드5\n상품코드6'
                  }
                />
              </td>
            </tr>
          </>
        )}
      </Modal>
      <JsonUpLoad
        propsData={jsonUpLoad}
        dataReqPromise={goodsInfoHeadUpLoad}
        customized={customizedUpLoad}
        propsHeadCells={upLoadTableHead}
      />
    </>
  );
};

export default ProductManagementGoodsInfoList;
